export var StatusValues = [
    'packing',
    'shipping',
    'transporting',
    'custom_clearance',
    'warehousing',
];
export var EstimatedDeliveryPeriodMonthParts = [
    'early',
    'mid',
    'late',
];
